import { useMutation } from '@tanstack/react-query';
import { api } from '~/services/api';
import { AxiosError } from 'axios';

type LineProps = {
  name: string;
  mobile: string;
  email: string;
  people: number;
  metadata: {
    partners: {
      accepted_marketing_agreement: boolean;
    };
  };
};

type LineParams = {
  params: LineProps;
  unit_id: string;
};

type GetLineProps = {
  data: {
    code: number;
    created_at: string;
    email: string;
    id: string;
    info: string;
    mobile: string;
    name: string;
    people: number;
    position: number;
    preferential: boolean;
    source: string;
    status: string;
    table: number;
    trackingUrl: string;
    unit_id: string;
    updated_at: string;
  };
};

type LineOptions = {
  onSuccess?: (data: GetLineProps) => void;
  onError?: (data: AxiosError) => void;
};

export const createLine = async (params: LineParams): Promise<GetLineProps> => {
  const { unit_id } = params;
  const { data } = await api.post(`/line/v1/units/${unit_id}/qrcode/lines`, {
    ...params.params,
  });

  return {
    data: data.data,
  };
};

export const useCreateLine = (options?: LineOptions) => {
  return useMutation<GetLineProps, AxiosError, LineParams>({
    mutationKey: ['line', 'create'],
    mutationFn: createLine,
    ...options,
  });
};
